// extracted by mini-css-extract-plugin
module.exports = {"Flex":"Flex_Flex__20qgR","Label":"Flex_Label__bYZiZ","optionValue":"Flex_optionValue__3qTCA"};